import { StoreGetUserFilterRequestOrderEnum } from "../api/main";
import { UserOrder } from "../store/slice/userSlice";

export const orderEnumConverter = (order: UserOrder): StoreGetUserFilterRequestOrderEnum => {
  switch(order) {
    case 'asc': return StoreGetUserFilterRequestOrderEnum.Asc;
    case 'desc': return StoreGetUserFilterRequestOrderEnum.Desc;
    default: return StoreGetUserFilterRequestOrderEnum.Asc;
  }
}